export default __webpack_public_path__ + "static/media/Dr._Nicole_Monteiro_AHV_In_Moms_We_Trust.b1517d9f.jpg";